import {SET_PRODORDERHIST_SEARCH} from '../constants/ActionTypes'

const initialState = {
    SearchText : '' 
};

export default function prodOrderHist(state = initialState, action) {
    switch (action.type) {
        case SET_PRODORDERHIST_SEARCH:
            if(state.SearchText !== action.searchText) {
                return Object.assign({}, state, {SearchText: action.searchText});
            }
            return state;
        default:
            return state;
    }
}